import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { login, getCompanyConfig } from "../api";
import KancelariaLogo from "../assets/kancelaria-logo.svg";
import "./LoginPage.css";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("access");
    if (!token) return;
    const features = getCompanyConfig()?.features || {};
    navigate(features.mailer ? "/mailer" : "/dashboard");
  }, [navigate]);

  async function handleLogin(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await login(email, password);
      const storedAccess = localStorage.getItem("access");
      if (!storedAccess) throw new Error("Access token not saved!");

      // Route to correct dashboard based on company features
      const features = data.company?.features || {};
      if (features.mailer) {
        window.location.href = "/mailer";
      } else {
        window.location.href = "/dashboard";
      }
    } catch (err) {
      if (err.response?.status === 401) setError("არასწორი ელ. ფოსტა ან პაროლი");
      else if (err.code === "ERR_NETWORK") setError("სერვერთან კავშირი ვერ მოხერხდა");
      else setError(err.message || "ავტორიზაცია ვერ მოხერხდა");
    }
    setLoading(false);
  }

  return (
    <div className="login-page">
      <div className="login-hero">
        <div className="login-hero-content">
          <img src={KancelariaLogo} alt="AI კანცელარია" className="login-hero-logo" />
          <div className="login-hero-divider" />
          <h1 className="login-hero-title">ელ. ფოსტის მართვის სისტემა</h1>
          <p className="login-hero-desc">
            ინტელექტუალური ელ. ფოსტის კლასიფიკაცია, მარშრუტიზაცია და მართვა AI ტექნოლოგიით
          </p>
          <div className="login-hero-features">
            <div className="login-feature">
              <div className="login-feature-icon">
                <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/></svg>
              </div>
              <span>AI კლასიფიკაცია</span>
            </div>
            <div className="login-feature">
              <div className="login-feature-icon">
                <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/></svg>
              </div>
              <span>დაცული კომუნიკაცია</span>
            </div>
            <div className="login-feature">
              <div className="login-feature-icon">
                <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z"/></svg>
              </div>
              <span>ავტომატური პასუხები</span>
            </div>
          </div>
        </div>
        <div className="login-hero-orbs">
          <div className="orb orb-1" />
          <div className="orb orb-2" />
          <div className="orb orb-3" />
        </div>
      </div>

      <div className="login-form-side">
        <div className="login-card">
          <div className="login-card-header">
            <h2>შესვლა</h2>
            <p>შეიყვანეთ თქვენი მონაცემები</p>
          </div>

          {error && <div className="login-error">{error}</div>}

          <form onSubmit={handleLogin} className="login-form">
            <div className="input-group">
              <label>ელ. ფოსტა</label>
              <div className="input-wrap">
                <svg className="input-icon" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="#94a3b8" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
                <input
                  type="email"
                  placeholder="name@company.ge"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
            </div>

            <div className="input-group">
              <label>პაროლი</label>
              <div className="input-wrap">
                <svg className="input-icon" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="#94a3b8" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/></svg>
                <input
                  type="password"
                  placeholder="შეიყვანეთ პაროლი"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
            </div>

            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? (
                <span className="login-spinner" />
              ) : (
                "შესვლა"
              )}
            </button>
          </form>

          <div className="login-footer">
            <span>AI კანცელარია &copy; {new Date().getFullYear()}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
